<template>
  <div>
    <div class="head">
      <div class="yf">
        <div class="mine-info" @click="$router.push({path:'/editUser',query:{id:id}})">
          <div class="mine-head-img">
            <van-image
              round
              fit="cover"
              width="100%"
              height="100%"
              :src="userinfo && userinfo.avatar ? userinfo.avatar : ''"
              alt=""
              v-if="userinfo"
            />
            <img v-else style="height:100%" ref="h1ele"/>
            <div class="edit-head-img">
              <i class="iconfont icon-bi"></i>
            </div>
          </div>
          <div class="mine-name">
            {{ userinfo && userinfo.name ? userinfo.name : "" }}
          </div>
        </div>
        <div class="collection">
          <div @click="$router.push({ path: '/focus', query: { type: 1 } })">
            <div class="num">
              {{ userinfo && userinfo.followNum ? userinfo.followNum : 0 }}
            </div>
            <span>关注</span>
          </div>
          <div class="line"></div>
          <div @click="$router.push({ path: '/focus', query: { type: 2 } })">
            <div class="num">
              {{ userinfo && userinfo.fansNum ? userinfo.fansNum : 0 }}
            </div>
            <span>粉丝</span>
          </div>
          <div class="line"></div>
          <div @click="$router.push('collection')">
            <div class="num">
              {{
                userinfo && userinfo.collectionNum ? userinfo.collectionNum : 0
              }}
            </div>
            <span>收藏</span>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 1rem"></div>
    <div class="rule">
      <i class="iconfont icon-lingdangwudian"></i>
      <div>推广规则</div>
    </div>

    <div class="order">
      <div class="my-order">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>分成比例</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mine-number" style="margin-top: 0.24rem">
      <div>
        <div class="mine-num-text">问答分成</div>
        <div class="mine-num">
          {{ (userinfo && userinfo.wTack ? userinfo.wTake : 0) + "%" }}
        </div>
      </div>
      <div class="fg-line"></div>
      <div>
        <div class="mine-num-text">课程分成</div>
        <div class="mine-num">
          {{ (userinfo && userinfo.kTake ? userinfo.kTake : 0) + "%" }}
        </div>
      </div>
      <div class="fg-line"></div>
      <div>
        <div class="mine-num-text">咨询分成</div>
        <div class="mine-num">
          {{ (userinfo && userinfo.zTake ? userinfo.zTake : 0) + "%" }}
        </div>
      </div>
    </div>
    <div class="vw-line"></div>

   

    <div class="menu" style="margin-bottom: 0.3rem">
      <div class="menu-item" style="padding-left: 0.28rem">
        <div class="menu-title">问答接单</div>
        <van-switch
          v-model="wdchecked"
          active-color="#4BD964"
          inactive-color="#dcdee0"
          @change="wdChange"
        />
      </div>
      <div class="menu-item" style="padding-left: 0.28rem">
        <div class="menu-title">咨询接单</div>
        <van-switch
          v-model="zxchecked"
          active-color="#4BD964"
          inactive-color="#dcdee0"
          @change="zxChange"
        />
      </div>
    </div>

    <div class="menu">
      <div
        class="menu-item"
        v-for="item in menu"
        :key="item.id"
        @click="onclickMenu(item)"
      >
        <div class="left-icon">
          <img :src="item.url" alt="" />
        </div>
        <div class="menu-title">{{ item.title }}</div>
        <div class="menu-more">
          <i class="iconfont icon-a-LeftArrow"></i>
        </div>
      </div>
      <!-- <div class="menu-item outlogin">
        <div class="menu-title" @click="tsignOut">{{userinfo ? '退出登录' : '登录'}}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
/**
@description:老师个人中心
@createTime:2021-09-01
@create:wq
*/
import {HERF} from '@/utils/tool.js'
import { shareJsSdk} from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      wdchecked: true,
      zxchecked: true,
      id:'',
      minedata: [
        {
          id: 1,
          num: 3,
          title: "咨询订单",
          isNew: false,
          prop: "zxAll",
          router: "zxorder",
        },
        {
          id: 2,
          num: 3,
          title: "闪测订单",
          prop: "wdConduct",
          router: "twdorder",
        },
        {
          id: 3,
          num: 3,
          title: "进行中的订单",
          prop: "zxConduct",
          router: "zxorder",
        },
        {
          id: 4,
          num: 3,
          title: "复购次数",
          prop: "repurchaseTimes",
        },
        {
          id: 5,
          num: 3,
          title: "发布的课程",
          prop: "kcNum",
          router: "tkc",
        },
        {
          id: 6,
          num: 3,
          title: "卖出的课程",
          prop: "kcComplete",
          router: "tkc",
        },
      ],
      menu: [
        // {
        //   id: 1,
        //   title: "我的发布",
        //   url: require("../../../assets/teacher/1.png"),
        //   href: "minefb",
        // },
        // {
        //   id: 2,
        //   title: "合作推广",
        //   url: require("../../../assets/teacher/2.png"),
        //   href: "spread",
        // },
        {
          id: 3,
          title: "我收到的评价",
          url: require("../../../assets/teacher/3.png"),
          href: "commentsReceived",
        },
        {
          id: 4,
          title: "快捷消息",
          url: require("../../../assets/teacher/4.png"),
          href: "phrase",
        },
        {
          id: 5,
          title: "抢单大厅",
          url: require("../../../assets/teacher/5.png"),
          href: "getWork",
        },
      ],
      userinfo: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.id;
    this.gettUserInfo();
    if(this.userinfo){
      this.msgPageNum();
    }
    shareJsSdk('tmine','可以测','国学传统文化 在线一对一咨询平台')
    this.$nextTick((callback=>{
      if(this.$refs.h1ele){
        this.$refs.h1ele.src = HERF+'/backstage/sx/'+this.getRandomInt(1,13)+'.png'
      }
    }))
  },
  methods: {
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
    },
    msgPageNum(){
      this.api.msgPageNum().then(res => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      })
    },
    wdChange() {
      this.api.openConsultOrProblem({ type: 0 }).then(() => {
        this.Toast.success("更改成功");
        this.gettUserInfo();
      });
    },
    zxChange() {
      this.api.openConsultOrProblem({ type: 1 }).then(() => {
        this.Toast.success("更改成功");
        this.gettUserInfo();
      });
    },
    onclickMenu(item) {
      let obj = {};
      obj.tid = this.id;
      if (item.href) this.$router.push({path:item.href,query:obj});
    },
    gettUserInfo() {
      this.api.userTeacherDetail({tid:this.id}).then((res) => {
        const obj = res.data;
        // localStorage.setItem("user", JSON.stringify(obj));
        this.userinfo = obj;
        this.wdchecked = obj.wNum == 0 ? true : false;
        this.zxchecked = obj.zNum == 0 ? true : false;
      });
    },
    tsignOut() {
      if(!this.userinfo){
        this.$router.push('/login')
        return
      }
      localStorage.clear();
      this.userinfo = null;
      this.$forceUpdate();
      this.$nextTick((callback=>{
        this.$refs.h1ele.src = HERF+'/backstage/sx/'+this.getRandomInt(1,13)+'.png'
      }))
      this.Toast.success("退出成功");
    },
    jump_page_r(item) {
      if(!localStorage.getItem('user')) return
      if (item.router) {
        if (item.id == 3) {
          this.$router.push({ path: item.router, query: {id:1}});
        } else if(item.id == 6){
          this.$router.push({ path: item.router, query: {id:1}});
        }else{
          this.$router.push(item.router);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 3.66rem;
  background-image: url("../../../assets/teacher/backimg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  //   overflow: hidden;
  position: relative;
}
.yf {
  height: 2.72rem;
  margin: 0 0.24rem;
  background: #ffffff;
  border-radius: 0.2rem;
  box-shadow: 0 3px 6px rgba($color: #7b7b7b, $alpha: 0.16);
  box-sizing: border-box;
  position: absolute;
  bottom: -0.76rem;
  left: 0;
  right: 0;

  //   transform: translateY(-50%);
  .collection {
    position: absolute;
    bottom: 0.42rem;
    width: 100%;
    display: flex;
    align-items: center;
    > div:not(.line) {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        font-size: 0.24rem;
        font-weight: 400;
        color: #999999;
      }
      .num {
        font-size: 0.4rem;
        font-weight: 400;
        color: #666666;
      }
    }
    .line {
      width: 1px;
      height: 0.38rem;
      background: #cccccc;
    }
  }
  .mine-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translateY(-0.6rem);

    .mine-head-img {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
      // overflow: hidden;
      border: 3px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      box-shadow: 0 3px 6px rgba($color: #000000, $alpha: 0.16);
      img {
        width: 100%;
        border-radius: 50%;
      }
      .edit-head-img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0.31rem;
        height: 0.31rem;
        background: #ffffff;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        i {
          font-size: 12px;
          color: #3c3d52;
          transform: scale(0.7);
        }
      }
    }
    .mine-name {
      font-size: 0.3rem;
      font-weight: 400;
      color: #333333;
      margin-top: 4px;
    }
    .integral {
      background: rgba($color: #000000, $alpha: 0.6);
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0.24rem;
      padding: 0 0.12rem 0 0.06rem;
      height: 0.48rem;
      margin-top: 2px;
      img {
        display: inline-block;
        width: 0.38rem;
      }
      span {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 40px;
        color: #f3b953;
        margin-left: 0.16rem;
        margin-right: 0.2rem;
      }
      i {
        color: #a59ea7;
        font-size: 12px;
      }
    }
  }
}
.rule {
  margin: 0.14rem 0.24rem;
  height: 0.8rem;
  background: #f6f8f8;
  border-radius: 0.22rem;
  padding: 0 0.26rem;
  display: flex;
  align-items: center;
  i {
    color: #f05468;
    font-size: 0.24rem;
  }
  > div {
    flex: 1;
    text-align: center;
    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
}
.mine-number {
  display: flex;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 0.3rem;
  > div:not(.fg-line) {
    flex: 1;
  }
  .fg-line {
    width: 1px;
    height: 0.38rem;
    background: #e6e6e6;
  }
  .mine-num {
    font-size: 0.4rem;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
  }
  .mine-num-text {
    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
}
.order {
  margin-top: 0.5rem;
  .my-order {
    margin: 0 0.24rem;
  }
  .modular-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      font-size: 0.32rem;
      font-weight: 400;
      color: #666666;
      display: flex;
      align-items: center;
      .title-line {
        width: 4px;
        height: 16px;
        background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
        opacity: 1;
        border-radius: 0px 4px 4px 0px;
        margin-right: 6px;
      }
    }
    .look-more {
      font-size: 0.22rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 6px;
      }
      i {
        font-size: 0.2rem;
      }
    }
  }
}
.profit {
  margin: 0.14rem 0.24rem;
  background: #f5f5f5;
  border-radius: 0.1rem;
  overflow: hidden;
  .balance {
    height: 2.26rem;
    background-image: url("../../../assets/teacher/balance.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 0.12rem 0.14rem;
    box-sizing: border-box;
    .balance-top {
      display: flex;
      align-content: center;
      justify-content: space-between;
      color: #ffffff;
      font-size: 0.24rem;
      font-weight: 400;
      .balance-top-left {
      }
      .balance-top-right {
        border-radius: 0.3rem;
        border: 1px solid #ffffff;
        padding: 0 5px;
      }
    }
    .balance-num {
      font-size: 0.6rem;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      span {
        font-size: 0.2rem;
      }
    }
    .balance-tx {
      margin: 0 auto;
      width: 2.88rem;
      height: 0.56rem;
      border-radius: 0.5rem;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #489eab;
      font-size: 0.24rem;
    }
  }
  .profit-data {
    display: flex;
    align-items: center;
    height: 1.08rem;
    .profit-line {
      width: 1px;
      height: 0.38rem;
      background: #e6e6e6;
    }
    .profit-data-item {
      flex: 1;
      text-align: center;
      .title {
        font-size: 0.24rem;
        font-weight: 400;
        color: #999999;
      }
      .num {
        font-size: 0.24rem;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.order-num {
  margin: 0.14rem 0.24rem;
  display: flex;
  justify-content: space-between;

  > div {
    width: 2.3rem;
    height: 1.62rem;
    background-image: url("../../../assets/teacher/order.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-top: 0.12rem;
    }
    .num {
      font-size: 0.4rem;
      font-weight: 400;
      color: #666666;
    }
  }
}

.mine-data {
  margin: 0.14rem 0.24rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .mine-data-item {
    width: 1.66rem;
    height: 1.66rem;
    background: #f5f5f5;
    border: 1px solid #e6e6e6;
    border-radius: 0.14rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    // margin-right: 0.12rem;
    margin-bottom: 0.12rem;
    .num {
      font-size: 0.4rem;
      font-weight: 400;
      color: #666666;
    }
    .text {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-top: 0.12rem;
    }
    .isNew {
      width: 0.16rem;
      height: 0.16rem;
      border-radius: 50%;
      background: #f9647d;
      position: absolute;
      top: 0.06rem;
      right: 0.06rem;
    }
  }
  .mine-data-item-last {
    width: 3.46rem;
    height: 1.66rem;
    background: #f5f5f5;
    border: 1px solid #e6e6e6;
    border-radius: 0.14rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;

    .num {
      font-size: 0.4rem;
      font-weight: 400;
      color: #f9647d;
    }
    .text {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-top: 0.12rem;
    }
  }
}
.menu {
  margin: 0.14rem 0.24rem;
  .menu-item {
    margin-bottom: 0.1rem;
    height: 0.88rem;
    background: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
    border-radius: 0.16rem;
    display: flex;
    align-items: center;
    padding: 0 0.26rem 0 0;
    .left-icon {
      width: 0.92rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.32rem;
      }
    }
    .menu-title {
      flex: 1;
      font-size: 0.28rem;
      font-weight: 400;
      color: #666666;
    }
    .menu-more {
      i {
        font-size: 12px;
        color: #cccccc;
      }
    }
  }
  .outlogin {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.22rem;
    .menu-title {
      color: #f9647d;
      text-align: center;
    }
  }
}
.vw-line {
  width: 100%;
  height: 6px;
  background: #f1f1f1;
}
</style>
